const rule = () => ({
    display: 'block',
    margin: 'auto',
    maxWidth: '20rem',
    '& .ant-btn': {
        display: 'block',
        margin: 'auto',
        width: '100%',
    },
});

export default rule;
